import classNames from 'classnames'
import BaseTooltip from 'components/BaseTooltip'
import DeleteIcon from 'mdi-react/DeleteIcon'
import React, { useCallback } from 'react'
import { useMutation } from 'react-query'
import { AsyncIconButton } from 'scenes/Dashboard/components-next/Button'
import { makeStyles } from 'tss-react/mui'

import { Theme } from '@mui/material'

import { useScoutingCampaignListViewStore } from '../ScoutingCampaignListViewStore'
import { ScoutingCampaign } from '../../../../../../../entities-next/scoutingCampaign'

type DeleteCorporateButtonProps = {
  className: string
  scoutingCampaign: ScoutingCampaign
}

export function DeleteScoutingCampaignButton({ className, scoutingCampaign }: DeleteCorporateButtonProps) {
  const { classes } = useStyles()
  const {
    actions: { deleteScoutingCampaign },
  } = useScoutingCampaignListViewStore()
  const { mutateAsync: handleScoutingCampaignDelete, status } = useMutation(deleteScoutingCampaign)
  const isLoading = status === 'loading'
  const handleClick = useCallback(() => handleScoutingCampaignDelete(scoutingCampaign), [
    handleScoutingCampaignDelete,
    scoutingCampaign,
  ])

  return (
    <BaseTooltip title="Delete user" bottom>
      <AsyncIconButton
        className={classNames(className, classes.iconContainer)}
        loading={isLoading}
        onClick={handleClick}
      >
        <DeleteIcon className={classes.fillParent} />
      </AsyncIconButton>
    </BaseTooltip>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  iconContainer: {
    width: spacing(4),
    height: spacing(4),
  },
  fillParent: {
    width: '100%',
    height: '100%',
  },
}))
